import { Component, Input, OnInit } from '@angular/core';
import { JsonConfiguration } from './json';
import { ITotalPriceResume } from '../../core/interfaces/ITotalPriceResume.interface';

@Component({
  selector: 'app-total-price-resume',
  templateUrl: './total-price-resume.component.html',
  styleUrls: ['./total-price-resume.component.scss'],
  providers: [JsonConfiguration]
})
export class TotalPriceResumeComponent implements OnInit {

  @Input() priceCardConfig: ITotalPriceResume;

  title: string = "";
  subtitle: string = "";
  priceSubtitle: string = "";
  protected: string = "";
  year: string = "";
  month: string = "";

  constructor(private jsonConfiguration: JsonConfiguration) {
  }

  ngOnInit(): void {
    const translateKey = this.priceCardConfig?.translateKey
    this.jsonConfiguration.setTranslateKey(translateKey);
    this.title = "Tu seguro por";
    this.subtitle = "Solamente ";
    this.priceSubtitle = "Único pago anual";
    this.protected = "Protegido por";
    this.year = "/año";
    this.month = "/mes";
  }
}
